import { event as e } from 'shared/experiments/utils/event'

export const CUSTOMER_RATINGS_CLICKED = e`Customer ratings clicked`
export const BRAUN_BANNER_CLICKED = e`Braun banner clicked`
export const SKINTIST_BANNER_CLICKED = e`Skintist banner clicked`
